import React, { useCallback, useEffect, useState } from "react";
import { IVideo } from "../hooks/useFetchVideos";
import { IFile, fetchTranscripts } from "./helpers";
import { CaptionsList } from "./CaptionsList";
import type { PanelStatus } from "./panels";

interface Props {
  /** The video's project: its brands' pre-approval setting gates "All". */
  project?: any;
  video: IVideo;
  onCount?: (n: number) => void;
}

export function CaptionsPanel({ video, project, onCount }: Props) {
  const [transcripts, setTranscripts] = useState<Array<IFile>>([]);
  const [status, setStatus] = useState<PanelStatus>("loading");
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    if (!video) return undefined;
    let live = true;
    setStatus("loading");
    fetchTranscripts(video)
      .then((found) => {
        if (!live) return;
        const all = found;
        setTranscripts(all);
        onCount?.(all.length);
        setStatus("ready");
      })
      .catch(() => {
        if (!live) return;
        setTranscripts([]);
        setStatus("error");
      });
    return () => {
      live = false;
    };
  }, [video, attempt]);

  return (
    <CaptionsList
      project={project}
      video={video}
      transcripts={transcripts}
      videoName={video?.name}
      bucket={video?.bucket}
      status={status}
      onRetry={retry}
    />
  );
}
